export const colors = {
  green: "#00abb3",
  darkGrey: "#1e2024",
  grey: "#494949",
  dark: "#000000",
  lightGrey: "#494949",
};
